<div [ngClass]="loadingWeek ? 'lock' : ''">
  <div class="flex flex-row">
    <h2 class="page-header">Plaatsing</h2>
    <div *ngIf="!loadingPlacers" class="employee-selector">
      <mat-form-field appearance="outline">
        <mat-select
          matInput
          placeholder="Installateur"
          [(ngModel)]="selectedEmployee"
          (ngModelChange)="selectedEmployeeChange()"
          name="employeeSelector"
          [compareWith]="compareEntities"
        >
          <mat-option
            *ngFor="let option of employeeOptions; trackBy: trackById"
            [value]="option"
            >{{
              option.user?.firstName | personName: option.user?.lastName
            }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="week-banner justify-content-between">
    <div *ngIf="loadingWeek" style="align-self: center;">
      <mat-spinner
        style="margin: auto;"
        color="primary"
        diameter="24"
      ></mat-spinner>
    </div>
    <div *ngIf="!loadingWeek" class="week-banner-container">
      <div class="week-banner-left-arrow">
        <mat-icon class="clickable" (click)="changeWeek(-1, true)"
          >arrow_back</mat-icon
        >
      </div>
      <ng-container *ngFor="let date of weekDates; let index = index">
        <div
          class="week-banner-item clickable"
          [ngClass]="selectedDateIndex === index ? 'selected' : ''"
          (click)="changeSelectedDateIndex(index)"
        >
          {{ date | formatMoment }}
        </div>
      </ng-container>
      <div class="week-banner-right-arrow">
        <mat-icon class="clickable" (click)="changeWeek(1, true)"
          >arrow_forward</mat-icon
        >
      </div>
    </div>
  </div>

  <div class="before-table-content">
    <button
      mat-flat-button
      class="action-button"
      [disabled]="loadingPlacers"
      (click)="openCreateEditOtherTaskModal()"
    >
      + Nieuwe taak
    </button>
    <div class="center-checkbox">
      <checkbox
        [text]="'Planning correct'"
        [checked]="taskList.checked"
        [isDisabled]="loadingTaskList || taskList.id == null"
        (answer)="taskListCheckedChange($event)"
      ></checkbox>
    </div>
  </div>

  <div class="d-flex">
    <div class="table-container panel flex-table">
      <div class="example-table-container">
        <div
          *ngIf="loadingTaskList"
          class="daily-planning-loader-overlay"
          style="margin-top: 55px; "
        >
          <div style="margin-top: 145px; align-self: center">
            <mat-spinner
              style="margin:auto;"
              color="primary"
              diameter="75"
            ></mat-spinner>
          </div>
        </div>
        <table
          #table
          mat-table
          [dataSource]="taskList.tasks"
          class="example-table"
          cdkDropList
          [cdkDropListData]="taskList.tasks"
          (cdkDropListDropped)="onListDrop($event)"
        >
          <ng-container matColumnDef="projectId">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Jobnummer</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [routerLink]="
                row.type !== 'SubProjectTask' && row.type !== 'LoadTask'
                  ? []
                  : ['/project', row.subProject?.project.id, row.subProject?.id]
              "
            >
              {{
                row.subProject?.project.id == null
                  ? ''
                  : '#' + row.subProject.project.id
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="taskInfo">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Opmerkingen</b>
            </th>
            <td mat-cell *matCellDef="let row" class="table-text">
              <ng-container *ngIf="row.type === 'SubProjectTask'">
                <div *ngIf="row.companiesDisplay?.length > 0">
                  <span class="strong">Klant: </span>
                  <span>{{ row.companiesDisplay }}</span>
                </div>
                <div *ngIf="row.subProject?.projectPlacement?.address != null">
                  <span class="strong">Adres: </span>
                  <span>{{
                    row.subProject?.projectPlacement?.address?.line1
                      | printAddress
                        : row.subProject?.projectPlacement?.address?.postalCode
                        : row.subProject?.projectPlacement?.address?.city
                  }}</span>
                </div>
                <div
                  *ngIf="row.subProject.projectPlacement?.appointment"
                  [matTooltip]="
                    row.subProject.projectPlacement?.needAppointmentInfo
                  "
                  [matTooltipDisabled]="
                    row.subProject.projectPlacement == null ||
                    row.subProject.projectPlacement.needAppointmentInfo ==
                      null ||
                    row.subProject.projectPlacement.needAppointmentInfo
                      .length === 0
                  "
                >
                  <span class="secondary-color strong">Afspraak info: </span>
                  <span class="secondary-color preserve-line-break">{{
                    row.subProject?.projectPlacement?.needAppointmentInfo
                      | shortenText: 100
                  }}</span>
                </div>
                <div
                  *ngIf="
                    row.subProject?.projectPlacement?.appointment &&
                    row.subProject?.projectPlacement?.collectKey
                  "
                >
                  <span class="strong">Sleutel afhalen: </span>
                  <span class="preserve-line-break">{{
                    row.subProject?.collectKeyFromAddress
                  }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="row.type === 'OtherTask'">
                <div *ngIf="row.title?.length > 0">
                  <span class="strong">Titel: </span>
                  <span>{{ row.title }}</span>
                </div>
                <div *ngIf="row.description?.length > 0">
                  <span class="strong">Omschrijving: </span>
                  <span class="preserve-line-break">{{ row.description }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="row.type === 'LoadTask'">
                <div *ngIf="row.companiesDisplay?.length > 0">
                  <span class="strong">Klant: </span>
                  <span>{{ row.companiesDisplay }}</span>
                </div>
                <div *ngIf="row.subProject?.projectPlacement?.address != null">
                  <span class="strong">Adres: </span>
                  <span>{{
                    row.subProject?.projectPlacement?.address?.line1
                      | printAddress
                        : row.subProject?.projectPlacement?.address?.postalCode
                        : row.subProject?.projectPlacement?.address?.city
                  }}</span>
                </div>
                <div *ngIf="row.description?.length > 0">
                  <span class="strong">Opmerkingen: </span>
                  <span class="preserve-line-break">{{ row.description }}</span>
                </div>
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="startTime">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Tijdstip</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [routerLink]="
                row.type !== 'SubProjectTask' && row.type !== 'LoadTask'
                  ? []
                  : ['/project', row.subProject?.project.id, row.subProject?.id]
              "
            >
              <span *ngIf="row.type === 'LoadTask'">{{
                row.startTime | appSubstring: 0:5 | or: '__:__'
              }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="timeBudget">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Doorlooptijd (min.)</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [routerLink]="
                row.type !== 'SubProjectTask' && row.type !== 'LoadTask'
                  ? []
                  : ['/project', row.subProject?.project.id, row.subProject?.id]
              "
            >
              {{ row.timeBudgetDisplay }}
            </td>
          </ng-container>
          <ng-container matColumnDef="productType">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Type(s)</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [routerLink]="
                row.type !== 'SubProjectTask' && row.type !== 'LoadTask'
                  ? []
                  : ['/project', row.subProject?.project.id, row.subProject?.id]
              "
            >
              <ng-container
                *ngIf="
                  row.type === 'SubProjectTask' ||
                  (row.type === 'LoadTask' && row.product == null)
                "
              >
                <div
                  class="line-height in-the-middle-left"
                  *ngFor="
                    let prod of row.subProject?.project.products;
                    trackBy: trackById
                  "
                  [matTooltip]="prod.type | productType: prod.otherProductName"
                >
                  {{
                    prod.type | abbreviatedProductType: prod.otherProductName
                  }}
                </div>
              </ng-container>
              <ng-container
                *ngIf="row.type === 'LoadTask' && row.product != null"
              >
                <div
                  class="line-height in-the-middle-left"
                  [matTooltip]="
                    row.product.type | productType: row.product.otherProductName
                  "
                >
                  {{
                    row.product.type
                      | abbreviatedProductType: row.product.otherProductName
                  }}
                </div>
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="taskType">
            <th mat-header-cell *matHeaderCellDef class="header-text"></th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [routerLink]="
                row.type !== 'SubProjectTask' && row.type !== 'LoadTask'
                  ? []
                  : ['/project', row.subProject?.project.id, row.subProject?.id]
              "
            >
              <ng-container
                *ngIf="
                  row.type === 'SubProjectTask' || row.type === 'OtherTask'
                "
              >
                <span
                  [ngClass]="
                    row.subProject?.type
                      | overviewProjectTypeClass
                        : row.subProject?.status
                        : row.subProject?.withPlacement
                        : row.subProject?.project?.typeMostRecentlyExecuted
                        : false
                        : 'taak'
                  "
                  class="clickable status"
                >
                  {{
                    row.subProject?.type
                      | overviewProjectType
                        : row.subProject?.status
                        : row.subProject?.withPlacement
                        : row.subProject?.project?.typeMostRecentlyExecuted
                        : 'Taak'
                  }}
                </span>
              </ng-container>
              <ng-container *ngIf="row.type === 'LoadTask'">
                <span class="load-task clickable status">Laden</span>
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="star" stickyEnd>
            <th mat-header-cell *matHeaderCellDef class="header-text"></th>
            <td
              mat-cell
              *matCellDef="let row"
              (click)="$event.stopPropagation()"
              class="table-text"
            >
              <mat-menu #actionMenu="matMenu" class="table-text">
                <button
                  *ngIf="row.type === 'SubProjectTask'"
                  mat-menu-item
                  (click)="openNotesModal(row)"
                  class="center-text"
                >
                  Pas opmerkingen aan
                </button>
                <button
                  *ngIf="row.type === 'OtherTask'"
                  mat-menu-item
                  (click)="openCreateEditOtherTaskModal(row)"
                  class="center-text"
                >
                  Bewerk taak
                </button>
                <button
                  *ngIf="row.type === 'LoadTask'"
                  mat-menu-item
                  (click)="openEditLoadTaskModal(row)"
                  class="center-text"
                >
                  Bewerk laadmoment
                </button>
                <button
                  *ngIf="row.type === 'LoadTask'"
                  mat-menu-item
                  (click)="toggleTaskActive(row)"
                  class="center-text"
                >
                  {{
                    row.active ? 'Deactiveer laadmoment' : 'Activeer laadmoment'
                  }}
                </button>
              </mat-menu>
              <div class="text-middle">
                <mat-icon
                  class="fa-2x no-background action-menu-align"
                  [matMenuTriggerFor]="actionMenu"
                  >more_vert
                </mat-icon>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            class="table-row"
            [ngClass]="
              row.active != null && row.active === false ? 'inactive-task' : ''
            "
            *matRowDef="let row; columns: displayedColumns"
            cdkDrag
            [cdkDragData]="row"
          ></tr>
        </table>
      </div>
      <div *ngIf="taskList.tasks.length === 0" class="no-result-text">
        <div>Geen resultaten gevonden</div>
      </div>
    </div>
    <div class="flex-map">
      <daily-planning-map
        [taskSubProjects]="subProjects"
        [addresses]="addresses"
      ></daily-planning-map>
    </div>
  </div>
</div>
